module.exports = __webpack_public_path__ + "static/media/shape3_1.bede42d1.obj";